import React from "react";
import { useNavigate } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function AccessDenied({ title = "Access denied", message }) {
  const navigate = useNavigate();
  return (
    <div className="min-h-[70vh] flex items-center justify-center p-6" data-testid="access-denied">
      <div className="text-center max-w-md">
        <span className="w-14 h-14 rounded-2xl bg-rose-50 text-rose-600 flex items-center justify-center mx-auto mb-4">
          <ShieldAlert className="w-7 h-7" />
        </span>
        <h1 className="text-2xl font-bold text-slate-900 tracking-tight">{title}</h1>
        <p className="text-sm text-slate-500 mt-2">
          {message || "You don't have permission to view this page. If you believe this is a mistake, contact your administrator."}
        </p>
        <Button className="mt-6 bg-indigo-600 hover:bg-indigo-700 text-white" onClick={() => navigate("/")} data-testid="access-denied-home">
          Back to dashboard
        </Button>
      </div>
    </div>
  );
}
